<template>
    <div class="content">
        <center>
            <h3 style="display:inline-block">Editar Correo al que se realizan los reclamos</h3>
            <i @click="showInfo()" class="el-icon-question help-icon"></i>        
        </center>
        <br><br>
        <div class="containerAdmin">
            <el-row :gutter="20">
                <el-col :xs="24" :md="10" :offset="8">
                    <label class="font-weight-bold">Email para recibir los reclamos</label><br>
                    <el-input v-model="mail" placeholder="example@exampleDomain.com"></el-input>
                </el-col>              
            </el-row>
            <br>            
            <el-row :gutter="20">                    
                <el-col :xs="24" :md="10" :offset="8">
                    <br>
                    <input @click="editTerms" value="Actualizar" class="btn btn-primary pill px-4 py-2">
                </el-col>        
            </el-row>      
        </div>
    </div>
</template>

<script>
import { db, storage } from '@/firebase.js'

export default {
    data () {
      return {        
        /*variables para la info */
        messaje: 'En este módulo le será posible actualizar el correo electrónico al que llegarán los correos de reclamos que se realizarán a su empresa, al cargar la página aparecerá el correo electrónico actual, solo debe editarlo y presionar el boton "actualizar" y ya el cambio estará realizado.',
        title: 'Actualizar Terminos y condiciones',
        /*fin variables para info */
        /* */       
        mail: '',        
        reclamosRef: db.child("reclamos")
      }
    },    
    methods:{
        async editTerms() {            
            try {
                const key = 'MailParaReclamos';                
                const update = {
                    mail: this.mail
                }
                await this.reclamosRef.child(key).set(update)                
                await this.getReclamoMail()
                // Y así puedes handlear el error como te de la puta gana we hee hee ayuwoki
            } catch (ex) {
                return console.error(ex)
            }
            this.success();           
        
        },         
        async getReclamoMail () {
            try {
                  let data = (
                    await db
                    .child("reclamos")                    
                    .once("value")                     
                ).val()

                this.mail = data.MailParaReclamos.mail
            } catch (ex) {
                return console.error(ex)
            }            
        },       
        success () {
            this.$message({
                message: 'Email de reclamos actualizado satisfactoriamente.',
                type: 'success'
            });
        },
        failure () {
            this.$message.error('Ha Ocurrido un error, intente de nuevo más tarde');
        },  
        showInfo() {
            this.$alert(this.messaje, this.title, {
                confirmButtonText: 'OK',          
            });
        }        
    }, 
    async created () {
        await this.getReclamoMail()
    }
}
</script>

<style scoped>
   
</style>



// WEBPACK FOOTER //
// Update.vue?ba698d3a